import Ajax from '@utils/ajax';

export default {
  getCurrentUserLinkedAccounts() {
    return Ajax.get({
      url: `/users/me/linked_accounts`,
    });
  },

  switchToAccount(newUserId) {
    return Ajax.post({
      url: `/sessions/switch_accounts`,
      data: { new_user_id: newUserId },
    });
  },

  linkAccounts(fromUserApiToken, toUserApiToken, linkMode) {
    return Ajax.post({
      url: `/users/link_accounts`,
      data: {
        from_user_api_token: fromUserApiToken,
        to_user_api_token: toUserApiToken,
        link_mode: linkMode,
      },
    });
  },
};
